import React from 'react';
import {TouchableOpacity} from 'react-native';
import styles from './Button.style';
const Button = ({...props}) => {
  const style = {
    backgroundColor: props.color,
    borderColor: props.border ? props.border : 'transparent',
  };

  if (!props.noWidth) {
    style.width = '100%';
  }
  return (
    <TouchableOpacity
      style={[styles.button, style, props?.style]}
      onPress={props.onPress}
      disabled={props.disabled ? props.disabled : false}>
      {props.children}
    </TouchableOpacity>
  );
};
export default Button;
